import React, { useState, useEffect } from "react";
import "./MembershipUpgradeForm.css";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { supabase } from "../supabase";

const MembershipUpgradeForm = () => {
  const navigate = useNavigate();
  const [selectedMembership, setSelectedMembership] = useState(null);

  // Default Navbar-related state
  const [selectedBookingType, setSelectedBookingType] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(false);
  const [selectedSport, setSelectedSport] = useState(null);

  // Toggle flag for "Coming Soon" message
  const isComingSoon = true; // Set to false to show the original content

  // Check authentication status and redirect if not authenticated
  useEffect(() => {
    const checkSession = async () => {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();
      if (error) {
        console.error("MembershipUpgrade.js: Error checking session:", error);
        navigate("/login");
        return;
      }
      if (!session) {
        // //console.log("MembershipUpgrade.js: No active session found, redirecting to login.");
        navigate("/login");
      }
    };

    checkSession();

    // Listen for auth state changes (e.g., after logout)
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (
          event === "SIGNED_OUT" ||
          (!session && event === "INITIAL_SESSION")
        ) {
          // //console.log("MembershipUpgrade.js: User signed out or no session, redirecting to login.");
          navigate("/login");
        }
      }
    );

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [navigate]);

  // Function to determine membership price
  const getMembershipPrice = (membership) => {
    if (membership === "Member") return 100;
    if (membership === "Premium Member") return 250;
    return 0;
  };

  const handleMembershipSelect = (membership) => {
    setSelectedMembership(membership);
    // Redirect to checkout page with selected membership
    navigate("/checkout", {
      state: {
        selectedMembership: membership,
        membershipPrice: getMembershipPrice(membership),
      },
    });
  };

  // Handle booking type selection to show the appropriate page
  const handleBookingTypeSelect = (type) => {
    // //console.log("MembershipUpgrade.js: handleBookingTypeSelect called with type:", type);
    const newState = {
      selectedBookingType: type,
      selectedProfile: false,
      selectedSport: null,
      selectedDate: null,
      selectedCourtType: null,
      selectedCourt: null,
      selectedTimeslots: [],
    };
    // //console.log("MembershipUpgrade.js: Navigating to / with state:", newState);
    navigate("/", { state: newState });
  };

  // Handle profile click to show the profile page
  const handleProfileClick = () => {
    // //console.log("MembershipUpgrade.js: handleProfileClick called");
    const newState = {
      selectedProfile: true,
      selectedBookingType: null,
      selectedSport: null,
      selectedDate: null,
      selectedCourtType: null,
      selectedCourt: null,
      selectedTimeslots: [],
    };
    // //console.log("MembershipUpgrade.js: Navigating to / with state:", newState);
    navigate("/profile", { state: newState });
  };

  return (
    <div className="membership-upgrade-container">
      <Navbar
        selectedSport={selectedSport || "Pickle"}
        selectedBookingType={selectedBookingType}
        onBookingTypeSelect={handleBookingTypeSelect}
        onProfileClick={handleProfileClick}
        isProfileActive={selectedProfile}
      />
      {isComingSoon ? (
        <div className="membership-coming-soon-message">
          <h2>Membership Upgrades - Coming Soon!</h2>
          <p>
            We're working on bringing membership upgrades to you. Stay tuned for
            updates!
          </p>
        </div>
      ) : (
        <div className="membership-plans-content">
          <h1 className="plans-title">Membership Plans</h1>
          <div className="membership-plans">
            <div className="membership-plan-card">
              <div className="price-circle">
                <span className="price">RM {getMembershipPrice("Member")}</span>
                <span className="per-month">/month</span>
              </div>
              <h2 className="plan-title">Member</h2>
              <ul className="plan-benefits">
                <li>10 days advanced booking</li>
                <li>2nd wave of pre-registration for internal tournaments</li>
              </ul>
              <button
                type="button"
                className="select-plan-button"
                onClick={() => handleMembershipSelect("Member")}
              >
                Select Plan
              </button>
            </div>
            <div className="membership-plan-card">
              <div className="price-circle">
                <span className="price">
                  RM {getMembershipPrice("Premium Member")}
                </span>
                <span className="per-month">/month</span>
              </div>
              <h2 className="plan-title">Premium Member</h2>
              <ul className="plan-benefits">
                <li>14 days advanced booking</li>
                <li>1st wave pre-registration for internal tournaments</li>
              </ul>
              <button
                type="button"
                className="select-plan-button"
                onClick={() => handleMembershipSelect("Premium Member")}
              >
                Select Plan
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipUpgradeForm;
